/* eslint-disable jsx-a11y/anchor-is-valid */
import useFetch from 'app/hooks/useFetch'
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup/redux/RootReducer'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget2,
  // MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  // ListsWidget4,
  // ListsWidget5,
  // ListsWidget6,
  // TablesWidget5,
  TablesWidget10,
  // MixedWidget8,
} from '../../../_metronic/partials/widgets'
import useTableCost from './useTableCost'
import { saveDataMinutaFood } from 'app/utils/indexedDB/IndexedDB'
import {
  getLStorage,
  setLStorage,
  jsonToExcel,
  chunkify,
  setSStorage,
  getSStorage,
  removeSStorage,
  copyObject,
} from '../../../global.d'

const DashboardPage: FC<any> = (props: any) => (
  <>
    {/* begin::Row */}
    
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-4'>
        <MixedWidget2
          className='card-xl-stretch mb-xl-4'
          chartColor='danger'
          chartHeight='200px'
          strokeColor='#cb1e46'
          tasks={props.tasks}
        />
      </div>
      {/* <div className='col-xxl-4'>
        <ListsWidget5 className='card-xxl-stretch' />
      </div> */}
      <div className='col-xxl-8'>
        {/* <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        /> */}
        <MixedWidget11
          className='card-xxl-stretch mb-5 mb-xxl-8'
          chartColor='primary'
          chartHeight='375px'
          chartSeries={props.chartSeries}
        />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 gx-xl-8'>
      <div className='col-xxl-4'>
        <ListsWidget3
          className='card-xxl-stretch mb-xl-3'
          links={props.links}
        />
      </div>
      <div className='col-xl-8'>
        <TablesWidget10
          className='card-xxl-stretch mb-5 mb-xl-8'
          header={props.table.header}
          data={props.table.data}
        />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div>
      {/* <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div> */}
      {/* <div className='col-xl-4'> */}
      {/* <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} /> */}
      {/* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
      {/* </div> */}
    </div>
    {/* end::Row */}

    {/* <div className='row g-5 gx-xxl-8'> */}
    {/* <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div> */}
    {/* <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div> */}
    {/* </div> */}
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { table, series } = useTableCost()
  const user: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
  const id: any = user.idUser ? user.idUser : user.id

  const statusMinuta: any[] = [
    { text: 'Minutas por publicar', value: 2 },
    { text: 'Minutas publicadas', value: 3 },
    { text: 'Minutas aprobadas - integradas', value: 6 },
    { text: 'Minutas por aprobar', value: 5 },
    { text: 'Minutas por integrar', value: 4 },
    { text: 'Alertas / Notificaciones', value: null },
    { text: 'Error: Integraciones minutas', value: null },
  ]

  // const { data: dataEstructuraMasivo, refetch: getDataGrid } = useFetch('amd_getGrupoEstructuraMasivo', {  })
  // setSStorage('dataEstructuraMasivo', dataEstructuraMasivo)
  

  const { data: linksInteres, refetch: getLinksInteres } = useFetch('amd_getLinkInteresbyUser', {
    parametros: [{ text: 'user', value: id.toString() }],
  })

  const { data: detalleInicio, refetch: getDetalleInicio } = useFetch('amd_getDetallePagInicio', {
    parametros: [{ text: 'usuario', value: id.toString() }],
  })

  const tareas: any[] = detalleInicio.map((e: any) => {
    return {
      ...e,
      text: statusMinuta.find((s: any) => s.value === e.version)?.text,
    }
  })

  saveDataMinutaFood("[]")
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage
        links={linksInteres}
        table={table}
        tasks={tareas}
        chartSeries={series}
      />
    </>
  )
}

export { DashboardWrapper }
